export function setupElementCopy(element, data = "", modalId = "") {
  if (!$(element).length) return;
  $(element).attr("data-clipboard-text", data);

  $(element).tooltip({
    trigger: 'click',
    placement: 'bottom'
  });

  let options = {};
  if (modalId) {
    options.container = document.getElementById(modalId)
  }
  // eslint-disable-next-line no-undef
  const clipboard = new Clipboard(element, options);

  clipboard.on('success', function (e) {
    setTooltip(e.trigger, 'Copied!');
    hideTooltip(e.trigger);
  });

  clipboard.on('error', function (e) {
    setTooltip(e.trigger, 'Failed!');
    hideTooltip(e.trigger);
  });
}

export function setTooltip(btn, message) {
  $(btn).tooltip('hide')
    .attr('data-original-title', message)
    .tooltip('show');
}

export function hideTooltip(btn) {
  setTimeout(function () {
    $(btn).tooltip('hide');
  }, 500);
}
